import $ from '@modules/jquery-import';
import View from '@core/View';
import appLogger from '@core/LoggingProvider';
import NewsletterService from '@services/NewsletterService';
import {jqueryValidate} from '@modules/lazy-imports';

const EMAIL_FIELD_SELECTOR = '#newsletterEmailAddress';
const MESSAGE_SELECTOR = '#newsletter-form-msg';

const emailForm = null;
const messageBar = null;

const lblThankYou = upi.i18n.getTextFromKey( 'lbl-thankYou' );
const lblEnterValidEmail = upi.i18n.getTextFromKey( 'lbl-enterValidEmail' );
const lblEmailFieldRequired = upi.i18n.getTextFromKey( 'lbl-emailFieldRequired' );
const lblErrorProcessingRequest = upi.i18n.getTextFromKey( 'lbl-errorProcessingRequest' );

const newsletterForm = {
    emailForm,
    messageBar,
    init ( formSelector ) {
        /* form validation and controller */
        this.emailForm = $( formSelector );

        if ( this.emailForm[0] ) {
            jqueryValidate().then( () => {
                const submitButton = this.emailForm.find( '.button' );
                const emailField = $( EMAIL_FIELD_SELECTOR );
                this.messageBar = $( MESSAGE_SELECTOR );

                const emailValidator = this.emailForm.validate( {
                    submitHandler: form => this.handleEmailSubmission( form, emailField )
                } );

                // success
                this.emailForm.on( 'email:reg-success', function () {
                    const origText = submitButton.text();
                    submitButton.addClass( 'success' ).text( lblThankYou );

                    setTimeout( () => {
                        submitButton.removeClass( 'success' ).text( origText );
                    }, 4000 );
                    emailField.val( '' ).blur();
                    emailValidator.resetForm();
                } );

                // fail
                this.emailForm.on( 'email:reg-error emailform:error', ( e, data = {} ) => {
                    let msg = '';
                    switch ( parseInt( data.status ) ) {
                        case 10:
                            msg = lblEnterValidEmail;
                            break;
                        case 11:
                            msg = lblEmailFieldRequired;
                            break;
                        default:
                            msg = lblErrorProcessingRequest;
                    }

                    if ( msg !== '' ) {
                        this.flashMessage( msg, 'error' );
                    }
                } );
            } );
        }
    },

    handleEmailSubmission ( form, emailField ) {
        const btn = $( form ).find( '.button' );
        const emailAddress = emailField.val().trim();
        btn.addClass( 'processing' );
        this.submitRegistration( emailAddress ).finally( () => btn.removeClass( 'processing' ) );
    },

    submitRegistration ( emailAddress ) {
        return NewsletterService.subscribe( emailAddress )
            .then( isSuccess => this.emailForm.trigger( isSuccess ? 'email:reg-success' : 'email:reg-error' ) )
            .catch( err => {
                appLogger.capture( err );
                this.emailForm.trigger( 'emailform:error', err )
            });
    },

    flashMessage ( message, type ) {
        type = type || '';
        if ( message ) {
            const view = new View( 'messagebox' );
            this.messageBar.html( view.render( {type, message} ) ).hide().slideDown( 200 );
        }
    }
};

export default newsletterForm;
